module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/twitter.d4d8b97e2258d2bdf2ffeae8b6e2e228.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/twitter.svg
// module id = 1675
// module chunks = 1